export default {
    namespaced: true,
    state: {
        parkingLoading: false,
        parkingList: [],
    },
    mutations: {
        updateParkingLoading(state, payload) {
            state.parkingLoading = payload;
        },
        updateParkingList(state, payload) {
            state.parkingList = payload;
        },
    },
};
